import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import type { MyOutlookProactiveDraftInfo } from "owa-personal-os-types";

export interface OpenDraftReplyFromBriefingActionMessage {
    messageId: string;
    body: string;
    mailboxInfo: MailboxInfo;
    conversationId?: string;
    /** @deprecated Never set; retained until callers outside apps/personalos are removed. */
    itemId?: string;
    /** @deprecated Never set; retained until callers outside apps/personalos are removed. */
    draftInfo?: MyOutlookProactiveDraftInfo;
    /** @deprecated Never set; retained until callers outside apps/personalos are removed. */
    briefingId?: string;
}

export const openDraftReplyFromBriefing: (messageId: string, body: string, mailboxInfo: MailboxInfo, conversationId?: string) => OpenDraftReplyFromBriefingActionMessage = action("OPEN_DRAFT_REPLY_FROM_BRIEFING", (messageId: string, body: string, mailboxInfo: MailboxInfo, conversationId?: string): OpenDraftReplyFromBriefingActionMessage => ({
    messageId,
    body,
    mailboxInfo,
    conversationId,
}));
